<div class="container py-[19px] px-0">
  <div class="mb-[26px] relative">
    <form [formGroup]="filterForm" class="overflow-x-auto">
      <table class="!bg-transparent w-full" fixedLayout mat-table [dataSource]="dataSource">

        <ng-container matColumnDef="date">
          <th class="min-w-[76px]" mat-header-cell *matHeaderCellDef
            [ngClass]="{'!w-[152px] !min-w-[152px] !max-w-[152px]': dataSource.data.length < 1}">Date</th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700 min-w-[76px]">
            <div class="flex flex-col">
              <!-- <span class="opacity-70">{{ element.timeCreated | date: 'HH:mm' }},</span> -->
              <span>{{ element.timeCreated | date: 'dd.MM.yyyy' }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="source">
          <th class="min-w-[127px]" mat-header-cell *matHeaderCellDef>
            @if (sortingList() && sortingList().sourceTypes.length > 1) {
            <mat-form-field class="table-head-select">
              <mat-label>Source</mat-label>
              <mat-select placeholder="Source" [panelClass]="'panel-table-head-select'" formControlName="sourceType">
                <mat-option [value]="null">All</mat-option>
                @for (source of sortingList().sourceTypes; track source) {
                @if ((source | lowercase) !== 'amlenergy' || isAmlEnergyActive()) {
                <mat-option [value]="source">
                  @switch ((source | lowercase)) {
                  @case ('amlenergy') {
                  AMLEnergy
                  }
                  @case ('monitor') {
                  Monitoring
                  }
                  @case ('cluster') {
                    EIS Signal
                  }
                  @default {
                  {{ source | titlecase }}
                  }
                  }
                </mat-option>
                }
                }
              </mat-select>
            </mat-form-field>
            } @else {
            <span>Source</span>
            }
          </th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700 min-w-[127px]">
            <div class="flex items-center gap-2">
              @switch ((element.sourceType | lowercase)) {
              @case ('amlenergy') {
              AMLEnergy
              }
              @case ('monitor') {
              Monitoring
              }
              @case ('cluster') {
                EIS Signal
              }
              @default {
              {{ (element.sourceType | titlecase) ?? '---' }}
              }
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="risk_score">
          <th class="min-w-[180px]" mat-header-cell *matHeaderCellDef>Risk Score</th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700 min-w-[180px]">
            @if ((element.type === 'INCOMING' || element.type === 'TRANSACTION_SCAN') && asIngoingTransaction(element);
            as ingoingTransaction) {
            @if (ingoingTransaction.latestAmlReport && ingoingTransaction.latestAmlReport.alerts &&
            ingoingTransaction.latestAmlReport.alerts.length > 0) {
            <div (click)="$event.stopPropagation()" [popoverTrigger]="popoverRiskInfo" [popoverTriggerOn]="'hover'"
              [popoverPanelClass]="'popover-panel-risk-score'" class="flex items-center gap-[10px] text-[14px]">
              <ng-container [ngTemplateOutlet]="switchRiskScore"></ng-container>
            </div>
            } @else {
            <div class="flex items-center gap-[10px] text-[14px]">
              <ng-container [ngTemplateOutlet]="switchRiskScore"></ng-container>
            </div>
            }
            } @else {
            <div class="flex items-center gap-[10px] text-[14px]">
              <ng-container [ngTemplateOutlet]="switchRiskScore"></ng-container>
            </div>
            }

            <ng-template #switchRiskScore>
              @if (element.sourceType === 'CLUSTER') {
              @if (element.type === 'BLOCKING') {
              <div class="flex items-center gap-1 bg-aml-green-700 rounded py-[3px] px-[7px]">
                <mat-icon svgIcon="risk-severe" class="w-[10px] max-w-[10px] h-[10px] max-h-[10px]"></mat-icon>
                <span class="text-white text-[11px]">Severe</span>
              </div>
              } @else {
              <div class="flex items-center gap-1 bg-aml-green-700 rounded py-[3px] px-[7px]">
                <mat-icon svgIcon="risk-severe" class="w-[10px] max-w-[10px] h-[10px] max-h-[10px]"></mat-icon>
                <span class="text-white text-[11px] whitespace-nowrap">Stolen funds</span>
              </div>
              }
              } @else {
              @switch (element.riskScore) {
              @case ('LOW') {
              <div class="flex items-center gap-1 bg-aml-green-600 rounded py-[3px] px-[7px]">
                <mat-icon svgIcon="risk-low" class="w-[7px] max-w-[7px] h-[7px] max-h-[7px]"></mat-icon>
                <span class="text-white text-[11px]">Low</span>
              </div>
              }
              @case ('MEDIUM') {
              <div class="flex items-center gap-1 bg-[#D3A500] rounded py-[3px] px-[7px]">
                <mat-icon svgIcon="risk-medium" class="w-[4px] max-w-[4px] h-[8px] max-h-[8px]"></mat-icon>
                <span class="text-aml-black-100 text-[11px]">Medium</span>
              </div>
              }
              @case ('HIGH') {
              <div class="flex items-center gap-1 bg-[#E74949] rounded py-[3px] px-[7px]">
                <mat-icon svgIcon="risk-high" class="w-[4px] max-w-[4px] h-[8px] max-h-[8px]"></mat-icon>
                <span class="text-white text-[11px]">High</span>
              </div>
              }
              @case ('SEVERE') {
              <div class="flex items-center gap-1 bg-aml-red-100 rounded py-[3px] px-[7px]">
                <mat-icon svgIcon="risk-severe" class="w-[10px] max-w-[10px] h-[10px] max-h-[10px]"></mat-icon>
                <span class="text-white text-[11px]">Severe</span>
              </div>
              }
              @default {
              ---
              }
              }
              }
            </ng-template>
            <ng-template #popoverRiskInfo>
              <div class="arrow"></div>
              <app-popover-container>
                @if ((element.type === 'INCOMING' || element.type === 'TRANSACTION_SCAN') &&
                asIngoingTransaction(element); as ingoingTransaction) {
                @if (ingoingTransaction.latestAmlReport) {
                @for (alert of ingoingTransaction.latestAmlReport.alerts; track $index) {
                <div
                  class="flex justify-between items-start pb-[6px] mb-[6px] border-b border-solid border-black border-opacity-5 last:pb-0 last:mb-0 last:border-none">
                  <div class="flex flex-col gap-1 items-start">
                    <span class="leading-[1.35] text-[14px] mb-1 font-bold text-[#234542]">
                      {{ alert.categoryId | triggerIdConvertToCategory | titlecase }}
                    </span>
                    <span
                      class="uppercase text-[12px] leading-[1] font-medium rounded-[60px] min-h-[15px] px-[6px] flex justify-center items-center"
                      [ngClass]="{
                              'border border-solid border-[#C92F29] text-[#C92F29]': alert.exposureType === 'INDIRECT',
                              'bg-[#C92F29] text-white': alert.exposureType !== 'INDIRECT'
                            }">
                      {{ alert.exposureType | titlecase }}
                    </span>
                  </div>
                  <div>
                    <app-report-status [risk]="alert.alertLevel"></app-report-status>
                  </div>
                </div>
                }
                }
                }
              </app-popover-container>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="deposit_wallet">
          <th class="min-w-[150px]" mat-header-cell *matHeaderCellDef>Deposit wallet</th>
          <td *matCellDef="let element" mat-cell class="min-w-[150px]">
            <div class="flex items-center pointer-events-auto">
              @if (element.target && element.type === 'WALLET_SCAN') {
              <span class="max-w-[140px] mr-1">{{ element.target | cropWithDotsCenter:5:5 }}</span>
              <app-copy-button (click)="$event.stopPropagation()" [currentColor]="'text-[#7A9095] opacity-50'"
                [value]="element.target" [size]="'small'"></app-copy-button>
              } @else {
              <span class="max-w-[140px] mr-1">{{ element.addressTo | cropWithDotsCenter:5:5 }}</span>
              <app-copy-button (click)="$event.stopPropagation()" [currentColor]="'text-[#7A9095] opacity-50'"
                [value]="element.addressTo" [size]="'small'"></app-copy-button>
              }
            </div>
          </td>
        </ng-container>
        
        <ng-container matColumnDef="case_status">
          <th class="min-w-[208px]" mat-header-cell *matHeaderCellDef>Case Status</th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700 min-w-[208px]">
            @switch (element.incidentProgressStep) {
              @case ('CASE_REPORTED') {
                <span class="flex items-center gap-2">
                  <span class="w-[12px] h-[12px] rounded-full bg-[#022D35]"></span>
                  <span class="text-[12px] text-[#6E707D] leading-[1]">Need action</span>
                </span>
              }
              @case ('TEMPORARY_FREEZE') {
                <span class="flex items-center gap-2">
                  <span class="w-[12px] h-[12px] rounded-full bg-[#FFD900]"></span>
                  <span class="text-[12px] text-[#6E707D] leading-[1]">Temporary freeze</span>
                </span>
              }
              @case ('LER_SENT') {
                <span class="flex items-center gap-2">
                  <span class="w-[12px] h-[12px] rounded-full bg-[#FFD900]"></span>
                  <span class="text-[12px] text-[#6E707D] leading-[1]">LEA request sent</span>
                </span>
              }
              @case ('PERMANENT_FREEZE') {
                <span class="flex items-center gap-2">
                  <span class="w-[12px] h-[12px] rounded-full bg-[#87C05A]"></span>
                  <span class="text-[12px] text-[#6E707D] leading-[1]">Permanent freeze</span>
                </span>
              }
              @case ('RECOVERY_OF_FUNDS') {
                <span class="flex items-center gap-2">
                  <span class="w-[12px] h-[12px] rounded-full bg-[#87C05A]"></span>
                  <span class="text-[12px] text-[#6E707D] leading-[1]">Recovery in process</span>
                </span>
              }
              @case ('CASE_CLOSED') {
                <span class="flex items-center gap-2">
                  <span class="w-[12px] h-[12px] rounded-full bg-[#87C05A]"></span>
                  <span class="text-[12px] text-[#6E707D] leading-[1]">Recovery successful</span>
                </span>
              }
              @default {
                <span>---</span>
              }
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="value">
          <th class="min-w-[120px]" mat-header-cell *matHeaderCellDef>Value</th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-600">
            @if (element.amount !== null && element.amount !== undefined) {
            @switch (element.coin) {
            @case ('USDT') {
            {{ (element.amount | cutNumber:('1.2-2')) ?? '---' }}
            }
            @default {
              {{ (element.amount | cutNumber:('1.2-18')) ?? '---' }}
            }
            }
            {{ element.coin ?? '---' }}
            } @else {
            {{ '---' }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="network">
          <th class="min-w-[100px]" mat-header-cell *matHeaderCellDef>Network</th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700 min-w-[100px]">
            <span class="opacity-30">{{ (element.network | changeNameTrxToTron) ?? '---' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="risky_amount">
          <th class="min-w-[152px]" mat-header-cell *matHeaderCellDef>Risky amount</th>
          <td *matCellDef="let element" mat-cell class="min-w-[152px]">
            <div class="flex items-center text-[#022D35]/30" [ngClass]="{ 'text-[#E74949]': element.riskyAmount > 0}">
              {{ (element.riskyAmount | cutNumber:('1.2-2')) ?? '---' }}
              @if (element.riskyAmount > 0) {
              <mat-icon class="text-[#778F8F] !w-[16px] !h-14px ml-1" [svgIcon]="'teather-icon'"></mat-icon>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="report_type">
          <th class="min-w-[136px]" mat-header-cell *matHeaderCellDef>
            @if (sortingList() && sortingList().amlScanTypes.length > 1) {
            <mat-form-field class="table-head-select !min-w-[120px]">
              <mat-label>Report type</mat-label>
              <mat-select placeholder="Report type" [panelClass]="'panel-table-head-select'"
                formControlName="amlScanType">
                <mat-option [value]="null">All</mat-option>
                @for (type of sortingList().amlScanTypes; track type) {
                <mat-option [value]="type">{{ type | transformUnderscoreToSpace | titlecase }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            } @else {
            <span>Report type</span>
            }
          </th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700 min-w-[136px]">
            @if (element.sourceType === 'CLUSTER') {
            Deposit
            } @else {
            @switch (element.type) {
            @case ('INCOMING') {
            {{ 'Deposit' }}
            }
            @case ('OUTGOING') {
            {{ 'Withdrawal' }}
            }
            @case ('TRANSACTION_SCAN') {
            {{ 'Transaction Check' }}
            }
            @case ('WALLET_SCAN') {
            {{ 'Wallet Check' }}
            }
            @default {
            {{ '---' }}
            }
            }
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th class="min-w-[105px]" mat-header-cell *matHeaderCellDef>
            <div class="flex items-center justify-between">
              <span>Action</span>
            </div>
          </th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700">
            @if (element.sourceType === 'CLUSTER') {
            @if (element.blockType) {
            @if (element.isBlockExpired) {
            <ng-container [ngTemplateOutlet]="block"></ng-container>
            } @else {
            @if (element.blockedBy) {
            <ng-container [ngTemplateOutlet]="review"></ng-container>
            } @else {
            <ng-container [ngTemplateOutlet]="blocked"></ng-container>
            }
            }
            } @else {
            <ng-container [ngTemplateOutlet]="block"></ng-container>
            }
            } @else {
            <ng-container [ngTemplateOutlet]="review"></ng-container>
            }

            <ng-template #review>
              <button type="button" mat-ripple
                class="btn-main text-[14px] font-medium text-[#2D67F7] border border-solid rounded-[4px] border-[#2D67F7] py-2 px-[18px]">
                Review
              </button>
            </ng-template>

            <ng-template #block>
              <button type="button" mat-ripple
                class="btn-main text-[14px] font-medium text-aml-red-800 border border-solid rounded-[4px] border-aml-red-800 py-2 px-[18px]">
                Block
              </button>
            </ng-template>

            <ng-template #blocked>
              <span class="text-[14px] leading-[1.3] text-aml-green-700/30">Blocked</span>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="table_settings" stickyEnd>
          <th class="table_settings" mat-header-cell *matHeaderCellDef>
            <!-- Заглушка для позиционирования настроек таблицы -->
            <div class="!w-[10px] !max-w-[10px]"></div>
          </th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700 hover-bg-sticky !bg-white !hidden"><span></span></td>
        </ng-container>

        <tr *matNoDataRow class="mat-mdc-row mdc-data-table__row">
          <td [attr.colspan]="displayedColumns.length" class="mat-mdc-cell mdc-data-table__cell !p-0"
            style="text-align: center">
            <!-- <div class="flex justify-center items-center px-5 py-10 max-w-[calc(100vw-56px)]"> -->
            <!-- <img alt="data-empty"
                  height="146"
                  priority
                  ngSrc="assets/icons/data-empty.svg"
                  width="227"> -->

            <app-empty-table [displayedColumns]="displayedColumnsEmpty" [columnWidth]="135"></app-empty-table>
            <!-- </div> -->
          </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="[&>th]:!bg-[#E4E5E5] [&>th]:!bg-opacity-40 [&>th]:font-normal text-aml-green-700 rounded-[7px]
            [&>th]:text-aml-green-700/40 [&>th]:!border-none !font-base
            !h-auto [&>th]:h-[44px] [&>th]:px-[10px] first:[&>th]:rounded-l-[7px] last:[&>th]:rounded-r-[7px]">
        </tr>
        <tr mat-row *matRowDef="let transaction; columns:displayedColumns"
          (click)="viewReport(transaction.uuid)"
          class="
            [&>td]:px-[10px] [&>td]:py-1 !bg-white hover:!bg-[rgba(45,103,247,0.05)]
            cursor-pointer shadow-table-row rounded-[6px] !h-[60px] !font-base new" [ngClass]="{
              'bg-row-open' : markOpenRow() === transaction.uuid,
              'not-viewed': !transaction.viewed,
              'blocked': isGrouped() && transaction.sourceType === 'CLUSTER' && transaction.type !== 'BLOCKING',
              'blocking': isGrouped() && transaction.sourceType === 'CLUSTER' && transaction.type === 'BLOCKING'
            }">
        </tr>
      </table>
    </form>

    @if (displayedColumns.includes('table_settings')) {
    <div class="absolute top-0 right-0 z-50 w-[36px] flex items-center justify-center h-[44px] bg-[#eef0f0] cursor-pointer">
      <mat-icon class="!w-[13px] !h-[13px]" svgIcon="settings" [matMenuTriggerFor]="menu"></mat-icon>
      <mat-menu class="menu-custom-scroll pr-[3px] py-[6px] !rounded-[9px]" #menu="matMenu" [hasBackdrop]="true">
        <div class="max-h-[316px] overflow-auto min-w-[225px]" cdkScrollable>
          <div cdkDropList class="menu-list" (cdkDropListDropped)="drop($event)">
            @for (displayedColumn of allDisplayedColumns; track displayedColumn) {
            @if (!['table_settings'].includes(displayedColumn)) {
            <div class="menu-item" cdkDrag>
              <mat-icon class="cursor-move !w-[6.5px]" cdkDragHandle svgIcon="aml_drag_handler"></mat-icon>
              <mat-checkbox (click)="$event.stopPropagation()"
                [ngModel]="!filteredDisplayedColumns.includes(displayedColumn)"
                (change)="handlerChangeDisplayColumnCheckbox($event, displayedColumn)"></mat-checkbox>
              {{ displayedColumn | transformUnderscoreToSpace | titlecase }}
            </div>
            }
            }
          </div>
        </div>
      </mat-menu>
    </div>
    }
  </div>
  @if (dataSource.data.length > 0) {
  <mat-paginator (page)="pageEvent.emit($event)" [length]="paginationOptions().length"
    [pageSizeOptions]="paginationOptions().pageSizeOptions" aria-label="Select page">
  </mat-paginator>
  } @else {
  <app-empty-pagination></app-empty-pagination>
  }
</div>
